
import Scroller from 'vux/src/components/scroller/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {eventBus} from '../../../eventbus'
export default {
data () {
return {
type: this.$route.params.type,
caseId: this.$route.params.caseid,
reportId: this.$route.params.reportid,
diagCropMin: '',
diagCropMax: '',
cropList: [],
cropAddrArray: [],
materialList: [],
materialArray: [],
samplePicShow: null,
eyeSeeShow: null,
eyeSeeTitle: '',
glassSeeShow: null,
glassSeeTitle: '',
diagnoseResultShow: null,
diagnoseResultTitle: '',
oneKnowledge: [],
knowledgeAss: [],
twoKnowledge: [],
threeKnowledge: [],
knowledgeAsstThree: [],
oneValue: [''],
twoValue: [''],
threeValue: [''],
oneShow: true,
twoShow: true,
threeShow: true,
iconfont: ['iconfont', 'tissue-report-edit-icon-padding'],
iconDown: 'icon-circle-down',
iconUp: ['icon-circle-up', 'tissue-report-edit-blue'],
innerCtn: 'tissue-report-edit-innerCtn',
innerCtnBig: 'tissue-report-edit-innerCtn-big',
caseDesc: '',
eyeSee: '',
glassSee: '',
diagnoseResult: '',
caseType: '',
fz: '',
canFinish: '',
canNextDoctor: '',
canNextHosp: '',
czCanFinish: '',
fzDoc: [''],
fzDocNames: '',
addFzShow: false,
tipShow: false,
tip: ''
}
},
components: { Scroller, Checker, CheckerItem, XTextarea, Group, Picker, GroupTitle, XButton, PopupRadio, XDialog, Flexbox, FlexboxItem },
beforeMount () {
this.$vue = this
this.getPageData()
},
methods: {
async assKnowledge (type, selectVal, val, caseId, knowId) {
if (selectVal.indexOf(val) > 0) {
let params = new URLSearchParams()
params.append('CASE_ID', caseId)
params.append('val', val)
if (knowId !== null && knowId !== '') {
if (knowId !== 'unexist') {
params.append('KNOW_ID', knowId)
} else {
params.append('KNOW_ID', '')
}
}
let suc = await this.$http.post(this.$vue.getData('GET_ASS_KNOWLEDGE'), params)
if (suc.data.result === '1') {
if (type === '1') {
if (suc.data.data.twoAssKnowledge.length > 0) {
this.twoValue = suc.data.data.twoAssKnowledge
}
if (suc.data.data.threeAssKnowledge.length > 0) {
this.threeValue = suc.data.data.threeAssKnowledge
}
} else if (type === '2') {
if (suc.data.data.oneAssKnowledge.length > 0) {
this.oneValue = suc.data.data.oneAssKnowledge
}
if (suc.data.data.threeAssKnowledge.length > 0) {
this.threeValue = suc.data.data.threeAssKnowledge
}
} else if (type === '3') {
if (suc.data.data.oneAssKnowledge.length > 0) {
this.oneValue = suc.data.data.oneAssKnowledge
}
if (suc.data.data.twoAssKnowledge.length > 0) {
this.twoValue = suc.data.data.twoAssKnowledge
}
}
}
}
},
async getPageData () {
let params = new URLSearchParams()

if (this.type === '0') {
params.append('CASE_ID', this.caseId)
let suc = await this.$http.post(this.$vue.getData('GO_DIAG_REPORT'), params)
if (suc.data.result === '1') {
if (suc.data.data.caseType === '2') {
this.diagCropMin = suc.data.data.pdModelConfig.DIAGNOSE_CROP_MIN
this.diagCropMax = suc.data.data.pdModelConfig.DIAGNOSE_CROP_MAX
this.samplePicShow = suc.data.data.pdModelConfig.SAMPLE_PIC_SHOW
this.eyeSeeShow = suc.data.data.pdModelConfig.EYE_SEE_SHOW
this.eyeSeeTitle = suc.data.data.pdModelConfig.EYE_SEE_TITLE
this.glassSeeShow = suc.data.data.pdModelConfig.GLASS_SEE_SHOW
this.glassSeeTitle = suc.data.data.pdModelConfig.GLASS_SEE_TITLE
this.diagnoseResultShow = suc.data.data.pdModelConfig.DIAGNOSE_RESULT_SHOW
this.diagnoseResultTitle = suc.data.data.pdModelConfig.DIAGNOSE_RESULT_TITLE
this.cropList = suc.data.data.cropList
this.cropAddrArray = suc.data.data.cropAddrArray
this.materialList = suc.data.data.materialList
this.materialArray = suc.data.data.materialArray
this.oneKnowledge = suc.data.data.oneKnowledge
this.knowledgeAss = suc.data.data.knowledgeAss
this.twoKnowledge = suc.data.data.twoKnowledge
this.threeKnowledge = suc.data.data.threeKnowledge
this.knowledgeAsstThree = suc.data.data.knowledgeAsstThree
this.caseType = suc.data.data.caseType
this.fz = suc.data.data.button.fz
this.canFinish = suc.data.data.button.canFinish
this.canNextDoctor = suc.data.data.button.canNextDoctor
this.canNextHosp = suc.data.data.button.canNextHosp
this.czCanFinish = suc.data.data.button.czCanFinish
this.fzDocNames = suc.data.data.fzDocNames
this.caseDesc = suc.data.data.caseDesc
this.eyeSee = this.caseDesc
}
}
}

if (this.type === '1') {
params.append('ID', this.reportId)
let succ = await this.$http.post(this.$vue.getData('COPY_REPORT'), params)
if (succ.data.result === '1') {
if (succ.data.data.pdCase.CASE_TYPE === 2) {
this.diagCropMin = succ.data.data.pdModelConfig.DIAGNOSE_CROP_MIN
this.diagCropMax = succ.data.data.pdModelConfig.DIAGNOSE_CROP_MAX
this.samplePicShow = succ.data.data.pdModelConfig.SAMPLE_PIC_SHOW
this.eyeSeeShow = succ.data.data.pdModelConfig.EYE_SEE_SHOW
this.eyeSeeTitle = succ.data.data.pdModelConfig.EYE_SEE_TITLE
this.glassSeeShow = succ.data.data.pdModelConfig.GLASS_SEE_SHOW
this.glassSeeTitle = succ.data.data.pdModelConfig.GLASS_SEE_TITLE
this.diagnoseResultShow = succ.data.data.pdModelConfig.DIAGNOSE_RESULT_SHOW
this.diagnoseResultTitle = succ.data.data.pdModelConfig.DIAGNOSE_RESULT_TITLE
this.cropList = succ.data.data.cropList
this.cropAddrArray = succ.data.data.cropAddrArray
this.materialList = succ.data.data.materialList
this.materialArray = succ.data.data.materialArray
this.eyeSee = succ.data.data.pdReport.EYE_SEE
this.twoValue = succ.data.data.pdReport.EYE_SEE.length === 0 ? [''] : succ.data.data.pdReport.EYE_SEE
this.glassSee = succ.data.data.pdReport.GLASS_SEE
this.threeValue = succ.data.data.pdReport.GLASS_SEE.length === 0 ? [''] : succ.data.data.pdReport.GLASS_SEE
this.diagnoseResult = succ.data.data.pdReport.DIAGNOSE_RESULT
this.oneValue = succ.data.data.pdReport.DIAGNOSE_RESULT.length === 0 ? [''] : succ.data.data.pdReport.DIAGNOSE_RESULT
this.caseType = succ.data.data.pdCase.CASE_TYPE
this.oneKnowledge = succ.data.data.oneKnowledge
this.knowledgeAss = succ.data.data.knowledgeAss
this.twoKnowledge = succ.data.data.twoKnowledge
this.threeKnowledge = succ.data.data.threeKnowledge
this.knowledgeAsstThree = succ.data.data.knowledgeAsstThree
}
}
}
},
oneChange () {
this.diagnoseResult = this.oneValue.toString().replace(/,/g, '')
},
twoChange () {
this.eyeSee = this.twoValue.toString().replace(/,/g, '')
},
threeChange () {
this.glassSee = this.threeValue.toString().replace(/,/g, '')
},
addFzDoc () {
this.addFzShow = true
},
async finishDiagnose (method) {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('cropAddrArray', this.cropAddrArray)
params.append('materialArray', this.materialArray)
params.append('samplePicShow', this.samplePicShow)
params.append('eyeSee', this.eyeSee)
params.append('glassSee', this.glassSee)
params.append('diagnoseResult', this.diagnoseResult)
params.append('method', method)
params.append('fzDoc', this.fzDoc.length === 1 ? '' : this.fzDoc.key)

eventBus.$emit('showLoading', true, '加载中')
let suc = await this.$http.post(this.$vue.getData('FINISH_DIAGNOSE'), params)
if (suc.data.result === '1') {

this.$router.push({ name: 'reportdetail', params: {data: suc.data.data, finishDiagnose: true} })
}

eventBus.$emit('showLoading', false)
},
back () {
this.$router.go(-1)
}
},
beforeRouteEnter (to, from, next) {

if (from.name === 'reportdetail') {
next({name: 'DzdCaseList'})
} else {
next()
}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/report/tissueReportEdit.vue